import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import i18n from './i18n';

// Translation provided by Vuetify (javascript)
import zhHant from 'vuetify/es5/locale/zh-Hant';

Vue.use(Vuetify, {
  lang: {
    locales: { zhHant },
    current: i18n.locale,
  },
  iconfont: 'mdi',
});
